import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Box, Skeleton } from "@mui/material";

/**
 * Loading skeleton component for ActiveFilters display
 * Shows placeholder content while filter data is being loaded
 * Matches the design of the actual ActiveFiltersDisplay component
 */
export const ActiveFiltersLoadingSkeleton = () => {
	return (
		<Box mb={1}>
			<BaseCard
				sxCardContent={{
					py: 1,
					px: 0,
					"&:last-child": {
						pb: 1,
					},
				}}
			>
				<Box
					display="flex"
					flexDirection={{ xs: "column", sm: "row" }}
					alignItems={{ xs: "stretch", sm: "center" }}
					justifyContent="space-between"
					marginLeft={2}
					marginRight={2}
					gap={{ xs: 1, sm: 2 }}
				>
					{/* Left side - Active Filters title and count */}
					<Box display="flex" flexDirection="column" gap={0.5} flexShrink={0}>
						<Box display="flex" alignItems="center" gap={1.5}>
							<Skeleton
								variant="text"
								width={140}
								height={20}
								sx={{
									fontSize: { xs: "0.75rem", sm: "0.875rem" },
									borderRadius: 1,
								}}
							/>
						</Box>
						<Skeleton
							variant="text"
							width={80}
							height={16}
							sx={{
								fontSize: { xs: "0.7rem", sm: "0.875rem" },
								borderRadius: 1,
							}}
						/>
					</Box>

					{/* Right side - Filter chips */}
					<Box flex="1" minWidth={0} mt={{ xs: 1, sm: 0 }}>
						<Box display="flex" flexWrap="wrap" gap={0.5}>
							{/* Simulate 3-4 filter chips */}
							<Skeleton
								variant="rectangular"
								width={110}
								height={24}
								sx={{
									borderRadius: 2,
									border: "1px solid",
									borderColor: "divider",
								}}
							/>
							<Skeleton
								variant="rectangular"
								width={95}
								height={24}
								sx={{
									borderRadius: 2,
									border: "1px solid",
									borderColor: "divider",
								}}
							/>
							<Skeleton
								variant="rectangular"
								width={125}
								height={24}
								sx={{
									borderRadius: 2,
									border: "1px solid",
									borderColor: "divider",
								}}
							/>
							{/* Clear all filters skeleton */}
							<Skeleton
								variant="rectangular"
								width={100}
								height={28}
								sx={{
									borderRadius: 2,
									border: "2px dashed",
									borderColor: "divider",
								}}
							/>
						</Box>
					</Box>
				</Box>
			</BaseCard>
		</Box>
	);
};
